import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const formatDate = (date: string, format: string): string | boolean => {
  if (!date) return false;
  return dayjs(date).format(format);
};
